export const types = {
    login: '[Auth] Login',
    logout: '[Auth] Logout',

    uiSetError: '[UI] Set Error',
    uiRemoveError: '[UI] Remove Error',

    uiStartLoading: '[UI] Start loading',
    uiFinishLoading: '[UI] Finish loading',

    productsAddNew: '[Products] New product',
    productsActive: '[Products] Set active product',
    productsLoad: '[Products] Load products',
    productsUpdated: '[Products] Updated product',
    productsFileUrl: '[Products] Updated image url',
    productsDelete: '[Products] Delete product',
    productsLogoutCleaning: '[Products] Logout Cleaning',
    addUrl: '[Products] Add Url',

    productsAllLoad: '[Products] all product Load'
}